/**
 * NORO.RS — Affiliate Tracking + Auto-Discount Script
 * v2.0 — bulletproof verzija
 *
 * Tok:
 *  A) Korisnik dolazi SA ?affiliate=KOD u URL-u
 *     → kod se čuva u cookie (30 dana)
 *     → cookie se upisuje u cart note_attributes
 *     → /discount/KOD se poziva da Shopify upamti kod za checkout
 *     → Shopify automatski povećava "Times used" kad se order kreira
 *
 *  B) Korisnik na checkoutu RUČNO unese discount code
 *     → Shopify prima samo jedan kod — nema duplog disconta
 *     → ako je affiliate cookie prisutan, note_attributes su i dalje upisani
 *       (za Klaviyo / TomOS tracking), samo discount nije dupliran
 *
 *  C) Korisnik dolazi BEZ affiliate URL-a, ali ima stari cookie
 *     → note_attributes se upisuju iz cookija
 *     → /discount/ se poziva ponovo (idempotentno, Shopify ne duplikuje)
 *
 *  D) Korisnik nema ni URL param ni cookie → skripta ne radi ništa
 */

;(function () {
  'use strict';

  // ─── KONFIGURACIJA ────────────────────────────────────────────────────────
  var AFFILIATE_PARAM  = 'affiliate';   // URL param:  ?affiliate=luka123
  var COOKIE_DAYS      = 30;            // Trajanje cookija u danima
  var ALL_PARAMS_COOKIE = 'noro_params'; // Cookie za sve URL params (note_attributes)
  var AFFILIATE_COOKIE  = 'noro_affiliate'; // Cookie samo za affiliate kod
  // ─────────────────────────────────────────────────────────────────────────

  // ── Helpers ───────────────────────────────────────────────────────────────

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; expires=' + date.toUTCString() +
      '; path=/' +
      '; SameSite=Lax'; // FIX #1: bez SameSite, neki browseri blokiraju cookie
  }

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      try {
        return decodeURIComponent(parts.pop().split(';').shift());
      } catch (e) {
        return null; // FIX #2: decodeURIComponent može baciti grešku na malformiranom cookiju
      }
    }
    return null;
  }

  // ── 1. Hvatanje URL parametara ────────────────────────────────────────────

  var urlParams = new URLSearchParams(window.location.search);
  var freshParams = {};

  urlParams.forEach(function (value, key) {
    freshParams[key] = value;
  });

  // Sačuvaj SVE params iz URL-a u cookie
  if (Object.keys(freshParams).length > 0) {
    setCookie(ALL_PARAMS_COOKIE, JSON.stringify(freshParams), COOKIE_DAYS);
    console.log('[Affiliate] URL params sačuvani:', freshParams);
  }

  // Ako postoji affiliate param → sačuvaj posebno (prepisuje stari cookie)
  if (freshParams[AFFILIATE_PARAM]) {
    setCookie(AFFILIATE_COOKIE, freshParams[AFFILIATE_PARAM], COOKIE_DAYS);
    console.log('[Affiliate] Affiliate kod sačuvan:', freshParams[AFFILIATE_PARAM]);
  }

  // ── 2. Čitanje cookija (koristi se u ostatku skripte) ─────────────────────

  var affiliateCode = getCookie(AFFILIATE_COOKIE);
  var storedParams  = null;
  var rawCookie     = getCookie(ALL_PARAMS_COOKIE);

  if (rawCookie) {
    try {
      storedParams = JSON.parse(rawCookie);
    } catch (e) {
      console.warn('[Affiliate] Malformiran noro_params cookie, ignorišem.');
    }
  }

  // FIX #3: ako nema storedParams iz cookija ali ima affiliate u URL-u,
  // koristi freshParams da ne izgubimo podatke u edge slučajevima
  if (!storedParams && Object.keys(freshParams).length > 0) {
    storedParams = freshParams;
  }

  // ── 3. Upis u cart note_attributes ───────────────────────────────────────
  // Radi uvek kada postoje parametri (iz URL-a ili cookija)
  // note_attributes = ono što ide u Klaviyo / TomOS na order nivou

  function updateCartAttributes(callback) {
    if (!storedParams) {
      if (callback) callback();
      return;
    }

    var attributes = {};
    Object.keys(storedParams).forEach(function (key) {
      attributes[key] = storedParams[key];
    });

    // Uvek dodaj affiliate posebno, čak i ako je u storedParams
    // da bi Klaviyo imao čist `affiliate` key bez obzira na ostale params
    if (affiliateCode) {
      attributes['affiliate'] = affiliateCode;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        console.log('[Affiliate] note_attributes upisani:', data.attributes);
        if (callback) callback();
      })
      .catch(function (e) {
        console.error('[Affiliate] Greška pri upisu note_attributes:', e);
        if (callback) callback(); // nastavi čak i ako ovo ne uspe
      });
  }

  // ── 4. Auto-discount logika ───────────────────────────────────────────────
  // FIX #4: originalna skripta je zvala /cart.js da proveri discount,
  // ali /cart.js NE vraća checkout-level discount kodove (oni živе na
  // checkout sesiji, ne na korpi). Jedini pouzdan način da ne dupliramo
  // je da pratimo da li SMO MI već pozvali /discount/ u ovoj sesiji.
  // Koristimo sessionStorage za to (briše se kad se tab zatvori).

  var DISCOUNT_APPLIED_KEY = 'noro_discount_applied';

  function applyAffiliateDiscount() {
    if (!affiliateCode) {
      console.log('[Affiliate] Nema affiliate koda — discount se ne primenjuje.');
      return;
    }

    // Da li smo već primenili u ovoj browser sesiji?
    if (sessionStorage.getItem(DISCOUNT_APPLIED_KEY) === affiliateCode) {
      console.log('[Affiliate] Discount već primenjen u ovoj sesiji, preskačem.');
      return;
    }

    // /discount/KOD — Shopify upisuje kod u checkout sesiju.
    // Ovo je idempotentno: ako korisnik ručno unese isti kod, Shopify
    // ga tretira kao jedan. Ako unese DRUGI kod, Shopify prima samo jedan
    // (poslednji koji je primenjen na checkout stranici).
    //
    // VAŽNO: fetch na /discount/ ne prikazuje stranicu korisniku,
    // samo setuje Shopify-ev checkout sesijski cookie sa kodom.
    fetch('/discount/' + encodeURIComponent(affiliateCode) + '?v=' + Date.now(), {
      method: 'GET',
      credentials: 'include',
    })
      .then(function (response) {
        if (response.ok || response.redirected) {
          sessionStorage.setItem(DISCOUNT_APPLIED_KEY, affiliateCode);
          console.log('[Affiliate] Discount primenjen:', affiliateCode,
            '| Shopify će povećati "Times used" kad se order kreira.');
        } else {
          console.warn('[Affiliate] /discount/ vratio status:', response.status,
            '— kod možda ne postoji u Shopify-u ili je istekao.');
        }
      })
      .catch(function (e) {
        // Fetch na /discount/ ponekad baca CORS grešku jer Shopify
        // redirectuje na checkout.shopify.com — to je ok, cookie je i dalje setovan
        console.log('[Affiliate] /discount/ fetch završen (moguć CORS redirect, to je normalno).');
        sessionStorage.setItem(DISCOUNT_APPLIED_KEY, affiliateCode);
      });
  }

  // ── 5. COD forma (ReConvert) ──────────────────────────────────────────────

  function injectIntoCodForm() {
    var form = document.querySelector('#_rsi-cod-form-modal-form');
    if (!form || !storedParams) return false;

    var injected = false;
    Object.keys(storedParams).forEach(function (key) {
      if (!form.querySelector('input[name="' + key + '"]')) {
        var input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = key;
        input.value = storedParams[key];
        form.appendChild(input);
        injected = true;
      }
    });

    // Affiliate posebno (ako nije u storedParams)
    if (affiliateCode && !form.querySelector('input[name="affiliate"]')) {
      var affInput = document.createElement('input');
      affInput.type  = 'hidden';
      affInput.name  = 'affiliate';
      affInput.value = affiliateCode;
      form.appendChild(affInput);
      injected = true;
    }

    if (injected) {
      console.log('[Affiliate] COD forma popunjena.');
    }
    return true; // forma postoji, bez obzira na injected
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    // 1. Upiši note_attributes, pa tek onda primeni discount
    //    (callback redosled je važan da ne bude race condition)
    updateCartAttributes(function () {
      applyAffiliateDiscount();
    });

    // 2. COD forma — odmah ili polling
    if (!injectIntoCodForm()) {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        injectIntoCodForm();
        if (attempts >= 30) { // max 30s
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  // Pokreni čim je DOM spreman (ili odmah ako već jeste)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init(); // DOMContentLoaded se već okidao (npr. skripta je na dnu <body>)
  }

})();
